export const CHECKOUT_URL = 'https://dentistas-it.impultienda.ar/checkout/'

export const volumes = [
  {
    number: 'VOLUME I',
    title: 'Fondamenti del Controllo Verticale',
    lead: 'Impara a valutare il sorriso, le relazioni verticali, il livellamento e i fattori clinici che influenzano il tuo piano di trattamento.',
    body: 'Identifica le considerazioni verticali più importanti prima di passare alla biomeccanica del trattamento.',
    accent: '#2f6fb5',
    items: [
      'Valutazione clinica',
      'Analisi del sorriso',
      'Relazioni verticali',
      'Considerazioni sul livellamento',
      'Errori comuni di pianificazione',
      'Framework visivi per il processo decisionale',
    ],
  },
  {
    number: 'VOLUME II',
    title: 'L’Arte dello Spazio: IPR vs. Espansione',
    lead: 'Impara ad affrontare la creazione di spazio senza andare a tentativi.',
    body: 'Comprendi i fattori clinici alla base dell’IPR, dell’espansione e delle altre strategie di gestione dello spazio.',
    accent: '#10a04f',
    items: [
      'Analisi dello spazio',
      'Considerazioni sull’IPR',
      'Considerazioni sull’espansione',
      'Rischi di proclination',
      'Framework decisionali',
      'Esempi clinici',
      'Errori comuni',
    ],
  },
  {
    number: 'VOLUME III',
    title: 'Attachments ad Alte Prestazioni',
    lead: 'Smetti di scegliere gli attachments semplicemente perché compaiono nel software.',
    body: 'Impara a considerarli in base al movimento e al sistema di forze che stai cercando di ottenere.',
    accent: '#0f8f96',
    items: [
      'Selezione degli attachments',
      'Strategie specifiche per ogni movimento',
      'Controllo delle rotazioni',
      'Controllo radicolare',
      'Intrusione ed estrusione',
      'Errori legati agli attachments',
      'Biomeccanica visuale',
    ],
  },
  {
    number: 'VOLUME IV',
    title: 'Protocolli Trasversali e Sagittali',
    lead: 'Costruisci un framework più chiaro per gestire i casi sagittali e trasversali più impegnativi con gli allineatori.',
    body: 'Approcci strutturati per i quadri clinici che generano più dubbi in pianificazione.',
    accent: '#7154b8',
    items: [
      'Classe II',
      'Classe III',
      'Morso crociato',
      'Discrepanze trasversali',
      'Distalizzazione',
      'Espansione',
      'Considerazioni sul sequencing',
    ],
  },
  {
    number: 'VOLUME V',
    title: 'Prevedibilità nel Movimento Radicolare',
    lead: 'Vai oltre il semplice movimento delle corone.',
    body: 'Comprendi cosa serve per controllare torque, posizione radicolare e tipping indesiderato durante il trattamento con allineatori.',
    accent: '#d99a20',
    items: [
      'Controllo del torque',
      'Movimento radicolare',
      'Tipping',
      'Sistemi di forza',
      'Sequencing',
      'Attachments per il controllo radicolare',
      'Errori biomeccanici comuni',
    ],
  },
  {
    number: 'VOLUME VI',
    title: 'Protocollo di Finalizzazione e Refinement',
    lead: 'Affronta la fase finale del trattamento con un processo di revisione strutturato.',
    body: 'Perché la finalizzazione non dovrebbe essere un ripensamento dell’ultimo momento.',
    accent: '#d4453f',
    items: [
      'Valutazione della fase finale',
      'Analisi occlusale',
      'Finalizzazione estetica',
      'Problemi di tracking',
      'Decisioni sui refinements',
      'Comunicazione con il tecnico',
      'Revisione finale',
      'Considerazioni sulla contenzione',
    ],
  },
]

export const bonuses = [
  {
    label: 'BONUS #1',
    title: 'Libreria di Istruzioni per la Comunicazione Clinica',
    subtitle: 'Oltre 80 istruzioni cliniche pronte all’uso',
    body: 'Smetti di perdere tempo cercando di spiegare esattamente cosa vuoi modificare in un piano di trattamento. Una biblioteca di istruzioni professionali da adattare quando comunichi obiettivi e modifiche al tuo tecnico o al team di pianificazione.',
    value: '€37',
    image: 'https://cdn.magicpatterns.com/uploads/5g6oF7RJauiQBeYNREK3JB/BONUS_1_DENTISTAS-IT.png',
  },
  {
    label: 'BONUS #2',
    title: 'La Checklist Clinica di Approvazione in 12 Punti',
    subtitle: 'La revisione finale di 3 minuti prima di approvare un caso',
    body: 'Una checklist pratica per controllare gli elementi critici prima di approvare un piano di trattamento. Usala come ultima rete di sicurezza prima di procedere.',
    value: '€27',
    image: 'https://cdn.magicpatterns.com/uploads/cYc9cCB6iKAbRiKijigT55/BONUS_2_DENTISTAS-IT.png',
  },
  {
    label: 'BONUS #3',
    title: 'Protocollo di Fotografia Clinica',
    subtitle: 'Migliori documentazioni cliniche prima di iniziare la pianificazione',
    body: 'I principali scatti fotografici necessari per documentare e valutare i casi con allineatori in modo coerente, con indicazioni su posizionamento, viste, organizzazione delle immagini ed errori da evitare.',
    value: '€29',
    image: 'https://cdn.magicpatterns.com/uploads/cFJtXPUwpd3DNvJ4hCGdaB/BONUS_3_DENTISTAS-IT.png',
  },
  {
    label: 'BONUS #4',
    title: 'Dashboard Clinica di Monitoraggio del Paziente',
    subtitle: 'Monitora visivamente l’andamento del trattamento',
    body: 'Una risorsa professionale per monitorare i progressi, confrontare i riscontri clinici con i movimenti pianificati e individuare eventuali deviazioni il prima possibile.',
    value: '€24',
    image: 'https://cdn.magicpatterns.com/uploads/bfdt78TpqwkPQmTK8hiBD1/BONUS_4_DENTISTAS-IT.png',
  },
  {
    label: 'BONUS #5',
    title: 'Script di Comunicazione con il Paziente ad Alto Impatto',
    subtitle: 'Scopri esattamente come spiegare le domande più frequenti',
    body: 'Script pronti da adattare che rendono i concetti clinici più complessi più facili da comprendere per i pazienti: IPR, attachments, durata del trattamento, refinements, compliance, aspettative e preoccupazioni più comuni.',
    value: '€37',
    image: 'https://cdn.magicpatterns.com/uploads/1rD8rMEJCGDk677TzsgqXd/BONUS_5_DENTISTAS-IT.png',
  },
]

export const painPoints = [
  'Stai osservando un ClinCheck e ti chiedi se il piano sia davvero pronto per essere approvato.',
  'Passi troppo tempo a rivedere lo stesso caso da prospettive diverse.',
  'Non sai con certezza quando IPR, espansione o distalizzazione siano la scelta più appropriata.',
  'A volte gli attachments vengono selezionati senza una chiara strategia biomeccanica.',
  'Alcuni casi richiedono refinements che avresti voluto prevedere prima.',
  'Dipendi eccessivamente dal software o dal tecnico per decidere se un piano sia appropriato.',
  'I casi complessi ti portano a mettere continuamente in discussione le tue decisioni.',
  'Conosci la teoria, ma applicarla in modo coerente ai casi reali è la parte più difficile.',
]

export const beforeList = [
  'Incertezza prima di approvare un ClinCheck',
  'Controllare ripetutamente lo stesso caso',
  'Andare a tentativi nella scelta della biomeccanica',
  'Attachments selezionati senza una strategia chiara',
  'Dettagli importanti trascurati',
  'Refinements evitabili',
  'Troppa dipendenza dal software',
  'Nessun processo di revisione coerente',
]

export const afterList = [
  'Segui un processo di revisione strutturato',
  'Analizzi ogni caso in modo sistematico',
  'Prendi decisioni cliniche con maggiore sicurezza',
  'Comprendi lo scopo di ogni meccanica',
  'Controlli i dettagli critici prima dell’approvazione',
  'Hai un framework più chiaro per i casi complessi',
  'Segui un flusso di pianificazione ripetibile',
  'Coerenza dalla diagnosi alla finalizzazione',
]

export const workflow = [
  { step: '1', title: 'Diagnosi', body: 'Comprendi il caso prima di scegliere la biomeccanica.' },
  { step: '2', title: 'Spazio', body: 'Valuta come lo spazio deve essere creato e gestito.' },
  { step: '3', title: 'Biomeccanica', body: 'Comprendi il movimento che stai chiedendo agli allineatori di produrre.' },
  { step: '4', title: 'Attachments', body: 'Seleziona gli attachments in base alla strategia di movimento.' },
  { step: '5', title: 'Revisione', body: 'Controlla i dettagli critici prima di approvare il piano.' },
  { step: '6', title: 'Finalizzazione', body: 'Valuta le fasi finali e decidi quando un refinement è appropriato.' },
]

export const planningQuestions = [
  'Qual è l’obiettivo clinico?',
  'Da dove verrà creato lo spazio?',
  'I movimenti sono correttamente sequenziati?',
  'Gli attachments supportano il movimento desiderato?',
  'Il controllo radicolare è stato considerato?',
  'Cosa potrebbe creare un problema più avanti?',
  'Cosa devo controllare prima di approvare?',
]

export const includedList = [
  '6 Volumi Clinici Specializzati',
  '5 Bonus Professionali Esclusivi',
  'Framework Visivi per le Decisioni',
  'Checklist Cliniche',
  'Esempi Basati su Casi',
  'Protocolli Pratici di Pianificazione',
  'Risorse per la Comunicazione con il Paziente',
  'Accesso Digitale Immediato',
]

export const valueStack = [
  {
    title: 'Biblioteca Clinica in 6 Volumi',
    price: '€97',
    body: 'Sei volumi specializzati che coprono il percorso di pianificazione dalla diagnosi alla finalizzazione.',
  },
  {
    title: 'Sistema Visivo di Decisione Clinica',
    price: '€67',
    body: 'Mappe decisionali, framework visivi e risorse strutturate per la pianificazione.',
  },
  {
    title: 'Biblioteca di Protocolli Clinici',
    price: '€47',
    body: 'Protocolli pratici progettati attorno alle decisioni più comuni nella pianificazione.',
  },
  {
    title: 'Biblioteca di Casi e Risorse Visive',
    price: '€49',
    body: 'Esempi clinici, diagrammi e risorse visive per facilitare l’apprendimento.',
  },
  {
    title: '5 Bonus Esclusivi',
    price: '€154',
    body: 'Strumenti aggiuntivi per pianificazione, comunicazione, documentazione e revisione.',
  },
]

export const testimonials = [
  {
    quote:
      'La differenza più grande per me è stata avere un metodo strutturato per rivedere i miei casi. Non ho più la sensazione di guardare semplicemente il ClinCheck sperando che tutto sia corretto.',
    name: 'Dr. Michael R.',
    role: 'Ortodonzista — Stati Uniti 🇺🇸',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/5eaf977a-3436-4e47-8eff-2aa92dafd460.jpg',
  },
  {
    quote:
      'I protocolli sono estremamente pratici. Ho apprezzato soprattutto le sezioni sulla gestione dello spazio e sugli attachments, perché ti offrono un framework invece di aggiungere altra teoria.',
    name: 'Dr.ssa Sarah L.',
    role: 'Odontoiatra — Regno Unito 🇬🇧',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/b63c129c-c82d-4584-801c-55fa1be8f931.jpg',
  },
  {
    quote:
      'L’approccio visivo rende molto più facili da comprendere concetti complessi. Posso immaginarmi di utilizzare queste risorse ripetutamente mentre pianifico i miei casi.',
    name: 'Dr. Daniel M.',
    role: 'Ortodonzista — Australia 🇦🇺',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/3e009299-0c4f-494b-9474-cfc9289eea16.jpg',
  },
  {
    quote:
      'La cosa che mi è piaciuta di più è che tutto è organizzato attorno a decisioni cliniche reali. È molto più facile da applicare rispetto a un altro manuale tradizionale.',
    name: 'Dr. James K.',
    role: 'Odontoiatra — Canada 🇨🇦',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/c6806cb9-93ca-4616-ba85-fb5b3f2ed1c5.jpg',
  },
]

export const audience = [
  {
    title: 'Ortodonzisti',
    body: 'Che desiderano un framework strutturato per analizzare e pianificare i casi con allineatori.',
  },
  {
    title: 'Odontoiatri',
    body: 'Che stanno integrando gli allineatori nella propria pratica e desiderano maggiore sicurezza nella pianificazione.',
  },
  {
    title: 'Specializzandi e inizio carriera',
    body: 'Che desiderano accelerare la propria comprensione attraverso framework pratici ed esempi clinici.',
  },
  {
    title: 'Professionisti esperti',
    body: 'Che desiderano standardizzare il proprio flusso di lavoro e creare un processo di pianificazione più coerente.',
  },
]

export const differentiators = [
  { title: 'Checklist', body: 'Per i punti di revisione più critici.' },
  { title: 'Framework decisionali', body: 'Per organizzare il tuo ragionamento clinico.' },
  { title: 'Diagrammi visivi', body: 'Per rendere più semplici da comprendere i concetti complessi.' },
  { title: 'Esempi basati su casi', body: 'Per collegare i principi agli scenari clinici reali.' },
  { title: 'Risorse pronte all’uso', body: 'Per aiutarti ad applicare il Sistema immediatamente.' },
]

export const faqs = [
  {
    q: 'Come riceverò il Sistema?',
    a: 'Riceverai l’accesso digitale immediato dopo aver completato l’acquisto. I materiali potranno essere consultati e scaricati dal tuo dispositivo.',
  },
  { q: 'È un libro fisico?', a: 'No. Si tratta di una biblioteca digitale a cui puoi accedere immediatamente dopo l’acquisto.' },
  { q: 'È un pagamento una tantum?', a: 'Sì. Paghi una sola volta e ricevi l’accesso digitale al materiale.' },
  {
    q: 'Funziona con diversi sistemi di allineatori?',
    a: 'Il Sistema è progettato come una risorsa educativa generale per aiutarti a strutturare il tuo processo di analisi e pianificazione clinica con gli allineatori.',
  },
  {
    q: 'È rivolto solo agli ortodontisti?',
    a: 'No. È stato creato per ortodontisti, odontoiatri e altri professionisti adeguatamente formati che pianificano e trattano casi con allineatori.',
  },
  {
    q: 'Sostituisce la mia formazione clinica o il mio giudizio professionale?',
    a: 'No. Il Sistema è una risorsa educativa progettata per aiutarti a organizzare il tuo processo di pianificazione. Ogni decisione clinica deve sempre basarsi sulla tua formazione, sul tuo giudizio professionale e sulle caratteristiche specifiche del paziente.',
  },
]

export const purchaseNotifications = [
  { name: 'Dr. Andrés M.', place: 'Buenos Aires, Argentina' },
  { name: 'Dr.ssa Lucía F.', place: 'Madrid, Spagna' },
  { name: 'Dr. Carlos R.', place: 'Città del Messico, Messico' },
  { name: 'Dr.ssa Valentina P.', place: 'Bogotá, Colombia' },
  { name: 'Dr. Javier S.', place: 'Santiago, Cile' },
  { name: 'Dr.ssa Camila T.', place: 'Lima, Perù' },
  { name: 'Dr. Martín G.', place: 'Montevideo, Uruguay' },
  { name: 'Dr.ssa Daniela V.', place: 'Quito, Ecuador' },
  { name: 'Dr. Rodrigo A.', place: 'Barcellona, Spagna' },
  { name: 'Dr.ssa Paula N.', place: 'Guadalajara, Messico' },
]
